import { restructureConfigList } from "../../OperatorManagement/Constant/ConfigFunction";
import { formatCellValue, formatDateForDisplay } from "../../Utils/UtilityFunctions";
import { Box } from "@mui/material";
import { DefaultRole } from "./constants";
export const userRoleManagementColoumns = () => {
    const columns = [
        {
            accessorKey: 'rolename',
            header: 'Role Name',
        },
        {
            accessorKey: 'roletype',
            header: 'Role Type',
            Cell: ({ cell }) => <RoleBadge roleName={cell.getValue()} />
        },
        {
            accessorKey: 'modules',
            header: 'Module Access',
            Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorKey: 'numberOfUsers',
            header: 'Number Of Users',
            Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
    ];

    return columns;
};

function RoleBadge({ roleName }) {
    if (!roleName) {
        return "-";
    }
    return (
        <Box
            sx={{
                display: "inline-block",
                px: 1.5,
                py: 1,
                borderRadius: 2,
                backgroundColor: roleName?.toLowerCase() === DefaultRole ? "#000000" : "#F5F6F7",
                color: roleName?.toLowerCase() === DefaultRole ? "#FFFFFF" : "#636363",
                border: `1px solid ${roleName?.toLowerCase() === DefaultRole ? "#000000" : "#F5F6F7"
                    }`,
                fontWeight: "bold",
            }}
        >
            {roleName?.toLowerCase() === DefaultRole?"Default":"Custom"}
        </Box>

    );
}
